export const AllAccountsConstants = Object.freeze({
  High_Yield_Savings: 'High Yield Savings',
});

export default AllAccountsConstants;
